import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faInstagram, faLinkedinIn, faVimeoV} from "@fortawesome/free-brands-svg-icons";
import SubFooter from "./SubFooter";

const Footer = () => {

    return(
        <>
        <div className="container-footer min-[320px]:p-6 xl:p-16">
            <div className="infos-boite">
                <h4 className="text-2xl">Focus Production</h4>
                <ul>
                    <li>
                        200 Cours Balguerie Stuttenberg,<br/> 33300 Bordeaux
                    </li>
                    <li>
                        <a href="mailto:simon@agencelemenu.fr">simon@agencelemenu.fr</a>
                    </li>
                    <li>
                        <a href="tel:0786113896">07 86 11 38 96</a>
                    </li>
                </ul>
            </div>

            <div className="menu-footer">
                <h4 className="text-2xl">Menu</h4>
                <ul>
                    <li><a href="/">Accueil</a></li>
                    <li><a href="/video/corporate">Vidéos</a></li>
                    <li><a href="/photographie">Photographie</a></li>
                    <li><a href="/realisations">Réalisations</a></li>
                    <li><a href="/#contact">Travaillons ensemble</a></li>
                    <li><a href="/mentions-legales">Mentions légales</a></li>
                </ul>
            </div>
            <div className="rs">
                <h4 className="text-2xl">Suivez-nous sur</h4>
                <div className="reseaux w-1/2">
                    <ul className="flex justify-between">
                        <li><FontAwesomeIcon className="mr-2 icon-footer" icon={faInstagram} /><a href="https://www.instagram.com/agencelemenu/" target="_blank" rel="noreferrer">instagram</a></li>
                        <li><FontAwesomeIcon className="mr-2 icon-footer" icon={faLinkedinIn} /><a href="https://www.linkedin.com/company/agence-le-menu/" target="_blank" rel="noreferrer">linkedin</a></li>
                    </ul>
                </div>
            </div>
        </div>
    <SubFooter/>
    </>
    )
}
export default Footer